import trimStart from 'lodash/trimStart'

export function serverUrl(url) {
  return (module.hot ? 'https://zion-benev.dev.loc/' : '/') + trimStart(url, '/')
}
